import { lazy } from "react";

const Home = lazy(() => import("../../pages/home/Home"));
const Jobs = lazy(() => import("../../pages/jobs/create/CreateJob"));
const ImportProfile = lazy(
  () => import("../../pages/importProfile/ImportProfile"),
);
const NotFound = lazy(() => import("../../../NotFound"));

export const lazyComponents = {
  Home,
  Jobs,
  ImportProfile,
  NotFound,
};
